import React, { useState, useRef } from 'react';
import ic_app_logo from "../img/autoland_logo_original.png";
import axios from 'axios';
import "../css/ImageUpload.css"

function ImageUpload() {

    const [selectedItemDescription, setSelectedItemDescription] = useState("")
    const [selectedItemCode, setSelectedItemCode] = useState(null)
    const [typedCharacters, setTypedCharacters] = useState(null)
    const [callingFileUploadAPI, setIsCallingFileUploadAPI] = useState(false)
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [arrayOfSearchResults, setArrayOfSearchResults] = useState();
    const [showLoadingStateViewLog, setShowLoadingStateViewLog] = useState(false);

    const timeInterval = useRef(null)

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImage(file);
        setPreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!image) return;

        const formData = new FormData();
        formData.append('image', image);

        // Replace this URL with your backend API
        const response = await fetch('http://localhost:5000/upload', {
            method: 'POST',
            body: formData,
        });

        const result = await response.json();
        console.log(result);
    };


    const clickedOnTableROw = (itemCodeFromClick, itemDescription) => {
        setSelectedItemCode(itemCodeFromClick)
        setSelectedItemDescription(itemDescription)
        setTypedCharacters(itemCodeFromClick)
        setArrayOfSearchResults(null)
    }

    const callApiToSendImages = async (e) => {

        e.preventDefault();
        if (!image) return;

        setIsCallingFileUploadAPI(true)

        const ticketFormData = new FormData();

        // autoland way
        // ticketFormData.append("image", {
        //     uri: pickerResponse.assets[0].uri, // your file path string
        //     name: 'my_photo.jpg',
        //     type: 'image/jpg'
        // });
        // ticketFormData.append("description", "dummyitem");
        // ticketFormData.append("UserId", "" + selectedItemCode);
        // ticketFormData.append("imagepath", "C");
        // autoland way

        let pathToStoreImage = `C:\\fileupload_common\\BONDTIME_DOC_IMG`
        //const apiUrl = `http://autoland.fortiddns.com:85/Posts`
        const apiUrl = `http://autoland1.fortiddns.com:85/Posts`
        //const apiUrl = 'https://cubixweberp.com:300/api/Image/upload'

        // previously here
        // ticketFormData.append('DOC_CODE', "doc123");
        // ticketFormData.append('DOC_TYPE', 'DOCIMAGE');
        // ticketFormData.append('IMAGEPATH', pathToStoreImage); // here we have added one more slash else this is result and 405 status error when sending to api "C:ileupload_commonBONDTIME_DOC_IMG"
        // ticketFormData.append('IMGBASE64', 'test')
        // ticketFormData.append('cmpcode', "cubix")
        // ticketFormData.append('file', image)
        // previously here

        // from app
        ticketFormData.append("image", image);
        ticketFormData.append("description", "dummyitem");
        ticketFormData.append("UserId", "" + selectedItemCode);
        ticketFormData.append("imagepath", "C");

        // from app ends

        try {
            axios({
                method: "post",
                url: apiUrl,
                data: ticketFormData,
                headers: { "Content-Type": "multipart/form-data" }
            }).
                then((res) => {

                    setIsCallingFileUploadAPI(false)

                    console.log(" task creation res is ", res);


                    if (res.data != null) {

                        if (res.data.imagepath.length > 0) {

                            alert("file upload success")
                            setSelectedItemCode(null)
                            setTypedCharacters("")

                        } else {
                            alert("file upload failed, please try later")
                        }


                    } else {
                        alert("file upload failed, please try later")
                    }
                }).
                catch((err) => {

                    setIsCallingFileUploadAPI(false)
                    console.log("err is -->>>>-- ", err, JSON.stringify(err));

                })
        } catch (error) {
            console.log("error when file upload ==>--- " + error)
            alert("something went wrong , please try later")
        }



    }


    const showLoadingForViewLog = () => {
        setShowLoadingStateViewLog(prev => !prev);
    }

    const callApi = (searchingText) => {
        showLoadingForViewLog();
        axios.get(`https://cubixweberp.com:196/api/Search_Items/Sitem/${searchingText}`).then((res) => {
            showLoadingForViewLog();
            console.log("api call success");
            setArrayOfSearchResults(res.data.result)
        }).catch(err => {
            console.log("error is ", err);
            showLoadingForViewLog();
        })
    }

    const handleInput = (e) => {

        console.log("typed --> ", e.target.value)


        setTypedCharacters(e.target.value)

        clearInterval(timeInterval.current);

        timeInterval.current = setTimeout(() => {

            if (e.target.value.length > 0) {

                if (timeInterval.current) {
                    console.log("timer is not null we are clearing it")
                    clearInterval(timeInterval.current);
                }
                callApi(e.target.value);

            } else {

                console.log("empty text entered ")
                setArrayOfSearchResults(null)


            }

        }, 1000)

    }


    return (
        <div>

            <div className='container'>
                <div className="Login-logo-container">
                    <img className="Header-app-logo"
                        style={{ width: "200px", margin: "20px" }}
                        src={ic_app_logo} />
                </div>

                <h4>Product Image Upload </h4>

                <h6>Search Item</h6>

                <div style={{ marginTop: 10, marginLeft: 0, marginRight: 10 }}>
                    <input autoComplete="off" value={typedCharacters} label="Enter item name" onChange={(e) => handleInput(e)} />
                </div>

                <div className='resultOfSearch'>

                    {
                        arrayOfSearchResults != null &&

                        arrayOfSearchResults.map((item) => {
                            return (
                                <div className='listItemOfSearch' onClick={() => clickedOnTableROw(item.Code, item.Description)} key={item.Code} >
                                    <div className='flex p-1'>
                                        <p style={{ fontWeight: "bold" }}>{item.Code}</p>
                                        <p style={{ marginLeft: "10px" }}>{item.Description}</p>
                                    </div>
                                </div>
                            )
                        })


                    }
                </div>


                {
                    selectedItemCode &&
                    <p className='mt-2'>Selected Item : <span style={{ backgroundColor: "#dedede", display: "inline-block", padding: 5 }}>{selectedItemCode}</span> <span style={{ backgroundColor: "#dedede", display: "inline-block", padding: 5 }}> {selectedItemDescription}</span></p>
                }


                <input className='mt-2' type="file" accept="image/*" onChange={handleImageChange} />
                {preview && <img src={preview} alt="Preview" width="200" />}
                <div className='mt-4'>
                    <button className='btn btn-primary' onClick={(e) => callApiToSendImages(e)}>Upload</button>
                </div>



            </div>

        </div>
    );
}

export default ImageUpload;
